var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-info",class:_vm.center && 'center'},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_c('a',[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_i2o4bjsec3mu56akmuw42haohq/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eea6ca02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_i2o4bjsec3mu56akmuw42haohq/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/HeadInfo.vue
// module id = null
// module chunks = 